<template>
  <div>
    <div class="lay_content">
      <projectHeader></projectHeader>
      <div class="lay_menu">
        <el-menu
          id="mediaMenu"
          @select="handleSelect"
          :default-active="$store.state.activeMenu"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#f5f5f5"
          text-color="#545c64"
          active-text-color="#2ea2fc"
          :unique-opened = "true"
        >
          <template v-for="(item,index) in menuList">
            <el-submenu :index="item.path" v-if="item.child">
              <template slot="title">
                <i :class="item.icon"></i>
                <span slot="title">{{item.title}}</span>
              </template>
              <el-menu-item v-for="(c,i) in item.child" :index="c.path" :key="i">{{c.title}}</el-menu-item>
            </el-submenu>             
            <el-menu-item :index="item.path" v-else>
              <i :class="item.icon"></i>
              <span slot="title">{{item.title}}</span>
            </el-menu-item>
          </template>
        </el-menu>
        <div class="myswiper" v-if="$store.state.bannerlist.length">
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide
              v-for="(item, index) in $store.state.bannerlist"
              :key="index"
            >
              <img :src="item.pic_url" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <div class="scroll-wrap">
        <el-backtop :visibility-height="60" target=".scroll-wrap" :bottom="100">
          <div
            style="
               {
                height: 100%;
                width: 100%;
                background-color: rgba(64, 158, 255, 0.4);
                box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
                text-align: center;
                line-height: 40px;
                color: #1989fa;
                border-radius: 50%;
                line-height: 40px;
              }
            "
          >
            <i class="el-icon-caret-top"></i>
          </div>
        </el-backtop>
        <v-Nav ref="menuNav"  v-if=" ['/home','/customer','/waitPrinted','/printed'].includes(getFrom)"></v-Nav>
        <transition  name="slide-left" mode="out-in">
            <router-view :key="$route.fullPath"></router-view>
        </transition>
      </div>
    </div>
    <v-cuservice></v-cuservice>
  </div>
</template>
<script>
import cuservice from '@/components/cuservice';
import projectHeader from "./header";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import layNav from "./layNav";
import { mapGetters } from "vuex";
let vm = null;
export default {
  name: "layout_main",
  data() {
    return {
      menuActive: "/home",
      menuList:[
        // {title:'订单打印',icon:'el-icon-printer',path:'/home'},
        {title:'订单打印',icon:'el-icon-printer',path:'1',child:[
          {title:'寄快递',path:"/home"},
          {title:'代客下单',path:"/customer"},
          {title:'待打印',path:"/waitPrinted"},
          {title:'已打印',path:"/printed"}
        ]},
        {title:'停发区查询',icon:'el-icon-search',path:'/stopArea'},
        {title:'批量导入',icon:'el-icon-upload',path:'/sheet'},
        // {title:'协议面单',icon:'el-icon-tickets',path:'/faceSheet'},
        // {title:'地址管理',icon:'el-icon-notebook-1',path:'/addressMenu'},
        // {title:'账号信息',icon:'el-icon-user-solid',path:'/peosonInfo'},
        // {title:'电子面单',icon:'el-icon-s-ticket',path:'/electronBill'},
        {title:'基础设置',icon:'el-icon-setting',path:'2',child:[
          {title:'打印设置',path:"/setTemplate"},
          {title:'地址薄',path:"/addressMenu"},
          {title:'电子面单',path:"/electronBill"},
          {title:'协议快递员',path:'/faceSheet'},
        ]},
      ],      
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },

        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        on: {
          click: function () {
            const realIndex = this.realIndex;
            vm.swiperGo(realIndex);
          },
        },
        // 设置点击箭头
        // navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev"
        // }
      },
    };
  },
  components: {
    projectHeader,
    // fontScroll,
    "v-Nav": layNav,
    'v-cuservice':cuservice,
    swiper,
    swiperSlide,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    ...mapGetters(["getFrom"]),
  },
  created() {
    vm = this;
    const activeMenu = this.$store.state.activeMenu;
    if (activeMenu) {
      this.menuActive = activeMenu;
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      if(key == '/home'){
        this.$router.push({ path: '/home' ,query: {id: 1}});
        this.$store.commit("SET_ROUTE_FROM", '/home');
        this.$store.state.nav_index = 0
        this.menuActive = '/home';
        this.$store.state.activeMenu = '/home'
      }else if(key == '/customer'){
        this.$router.push({ path: '/home' ,query: {id: 2}});
        this.$store.commit("SET_ROUTE_FROM", '/customer');
        this.$store.state.nav_index = 1
        this.menuActive = '/customer';
        this.$store.state.activeMenu = '/customer'
      }else{
        this.$router.push({ path: key });
        this.menuActive = key;
        this.$store.commit("SET_ROUTE_FROM", key);
      }
    },
    swiperGo(index) {
      const item = this.$store.state.bannerlist[index];
      if (item.title == "_blank") {
        window.open(item.link_url);
      } else if (item.title == "_self") {
        window.location.href = item.link_url;
      } else {
        console.log("banner title配置错误");
      }
    },
  },
  mounted() {},
};
</script>
<style lang="stylus">
.lay_content{
    padding-top 50px
}
.lay_menu{
    position: fixed;
    left: 0;
    top: 50px;
    height: calc(100vh - 80px);
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .myswiper{
        width: 100%;
        height: 160px;
        .swiper-container{
            position: relative;
            width: 100%;
            height: 100%;
            .swiper-slide{
                width: 100%;
                height: 100%;
                color: #000;
                font-size: 16px;
                text-align: center;
                img{
                    width: 100%;
                    height: 100%
                }
            }
        }
    }
}
.scroll-wrap{
    position: absolute;
    width: calc(100% - 180px);
    height: calc(100vh - 80px);
    min-width: 980px;
    margin: 0 auto;
    // overflow: scroll;
}
.scroll-wrap::-webkit-scrollbar {
    display: none;
}
@media screen and (max-width: 1024px) {
  #mediaMenu{
      width: 140px
  }
  .scroll-wrap{
      left:140px
  }
  .lay_menu{
     width: 140px
     .myswiper{
         height: 140px
     }
  }
}
@media screen and (min-width: 1025px) and (max-width: 1279px){
  #mediaMenu{
      width: 160px
  }
  .scroll-wrap{
      left:160px
  }
  .lay_menu{
     width: 160px
     .myswiper{
         height: 160px
     }
  }
}
@media screen and (min-width: 1280px) and (max-width: 1440px){
  #mediaMenu{
      width: 180px
  }
  .scroll-wrap{
      left:180px
  }
  .lay_menu{
     width: 180px
     .myswiper{
         height: 180px
     }
  }
}
@media screen and (min-width: 1441px)and (max-width: 2048px) {
  #mediaMenu{
      width: 180px
  }
  .scroll-wrap{
      left:180px
  }
  .lay_menu{
     width: 180px
     .myswiper{
         height: 180px
     }
  }
}
@media screen and (min-width: 2049px) {
  #mediaMenu{
      width: 180px
  }
  .scroll-wrap{
      left:180px
  }
  .lay_menu{
     width: 180px
     .myswiper{
         height: 180px
     }
  }
}
.slide-left-enter {
  opacity: 0;
  -webkit-transform: translate(50px, 0px);
  transform: translate(-50px,0px);
}
.slide-left-enter-active{
  transition: all 0.2s linear;
}
.slide-left-leave-to{
  opacity: 0;
  -webkit-transform: translate(-50px,0px );
  transform: translate( 50px,0px);
  display: none;
}
.slide-left-leave-active {
  transition: all 0.2s linear;
}
.el-submenu .el-menu-item{
  min-width: 140px !important;
  height: 40px  !important;
  line-height: 40px  !important;
} 
</style>
